export default __webpack_public_path__ + "static/media/durvis-16-min.22b5afd2.jpg";